module.exports = __webpack_public_path__ + "static/media/banner_compendioC5_.695d9d58.jpg";